module.exports = __webpack_public_path__ + "img/loading.536b235e.png";